import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import Modal from "ui/Modal/Modal";
import ProductInfo from "common/ProductPreview/components/BundleList/components/ProductInfo/ProductInfo";
import { useStore } from "store";
import { useApi } from "services/ApiService";
import styles from "./ProductModal.module.scss";

type Props = {
  item: Entity.Product.BundleBadge;
  onClose: () => void;
};

const ProductModal: React.FC<Props> = ({ item, onClose }: Props) => {
  const { location } = useStore();
  const [product, setProduct] = useState(null);
  const {
    methods: { products },
  } = useApi();

  useEffect(() => {
    async function fetch() {
      const { data, errors } = await products.search({
        search: {
          productIDs: [item.id],
          regionID: location.regionID,
        },
      });

      if (data?.products && data?.products.items.length) {
        setProduct(data?.products.items[0]);
      }

      if (errors) {
        console.error(errors);
      }
    }

    fetch();
  }, [products]);

  return (
    <div className={styles.productModal}>
      <Modal onClose={onClose}>
        <ProductInfo product={product} type="modal" />
      </Modal>
    </div>
  );
};

export default observer(ProductModal);
